import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { COMPONENT_BY_SCREEN } from '@/constants/ComponentByScreen';

export const DesktopViewer = () => {
  const {
    viewer: { screen },
  } = useContext(CheckoutContext);

  if (screen) {
    const Component = COMPONENT_BY_SCREEN[screen];
    return (
      <div className="contents">
        <Component />
      </div>
    );
  }
  return null;
};
